export default "/assets/images/problem-solved-10.7296bb84de085ecb.webp";